export default "__VITE_ASSET__fqGfHsrz__"